import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

/** Quadro para desenhar a assinatura com mouse ou toque. getBlob() devolve PNG. */
export function SignaturePad({ onReady }) {
    const canvasRef = useRef(null);
    const drawing = useRef(false);
    const [hasInk, setHasInk] = useState(false);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.strokeStyle = "#0b1e8b";
        ctx.lineWidth = 3;
        ctx.lineCap = "round";
        ctx.lineJoin = "round";
        onReady({ getBlob: () => new Promise((res) => canvas.toBlob(res, "image/png")) });
    }, [onReady]);

    const pos = (e) => {
        const rect = canvasRef.current.getBoundingClientRect();
        const scaleX = canvasRef.current.width / rect.width;
        const scaleY = canvasRef.current.height / rect.height;
        const point = e.touches ? e.touches[0] : e;
        return [(point.clientX - rect.left) * scaleX, (point.clientY - rect.top) * scaleY];
    };

    const start = (e) => {
        e.preventDefault();
        drawing.current = true;
        const ctx = canvasRef.current.getContext("2d");
        ctx.beginPath();
        ctx.moveTo(...pos(e));
    };
    const move = (e) => {
        if (!drawing.current) return;
        e.preventDefault();
        const ctx = canvasRef.current.getContext("2d");
        ctx.lineTo(...pos(e));
        ctx.stroke();
        setHasInk(true);
    };
    const end = () => { drawing.current = false; };

    const clear = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        setHasInk(false);
    };

    return (
        <div data-testid="signature-pad">
            <label className="block font-mono-tag text-xs font-bold uppercase tracking-wider text-black mb-2">
                Desenhe sua assinatura
            </label>
            <canvas
                ref={canvasRef}
                width={600}
                height={200}
                onMouseDown={start}
                onMouseMove={move}
                onMouseUp={end}
                onMouseLeave={end}
                onTouchStart={start}
                onTouchMove={move}
                onTouchEnd={end}
                data-testid="signature-canvas"
                className="w-full border-2 border-black bg-white touch-none cursor-crosshair"
                aria-label="Área para desenhar a assinatura"
            />
            <div className="flex items-center justify-between mt-2">
                <span className="font-mono-tag text-[11px] text-gray-500">
                    {hasInk ? "Assinatura capturada" : "Assinatura visual (imagem) — não é certificado ICP-Brasil"}
                </span>
                <button
                    type="button"
                    onClick={clear}
                    data-testid="signature-clear"
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 border-2 border-black bg-white font-mono-tag text-[11px] font-bold uppercase hover:bg-black hover:text-white transition-colors"
                >
                    <Eraser className="w-3.5 h-3.5" aria-hidden="true" /> Limpar
                </button>
            </div>
        </div>
    );
}
